<template>
    <v-container
            grid-list-xs
    >
        <v-layout row wrap>
            <v-flex xs12 text-xs-center layout align-center justify-center>
                <h1>Discover</h1>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: 'discover',
        data() {
            return {};
        },
        computed: {},
        methods: {},
        created() {},
    };
</script>



// WEBPACK FOOTER //
// Discover.vue?66de3c62